import { render, staticRenderFns } from "./CollectSpecSoftTable.vue?vue&type=template&id=cb89094e"
import script from "./CollectSpecSoftTable.vue?vue&type=script&lang=js"
export * from "./CollectSpecSoftTable.vue?vue&type=script&lang=js"
import style0 from "./CollectSpecSoftTable.vue?vue&type=style&index=0&id=cb89094e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports